export default __webpack_public_path__ + "static/logo-alfredo-white-2221a6bebe3f159174b8200da4246054.png";